import ReactApexChart from 'react-apexcharts';
import { Typography } from 'antd';
import lineChart from './configs/lineChart';

function LineChart({
  title = 'Active Users',
  options = lineChart.options,
  series = [],
  height = 350,
  width = '100%',
  topRightChildren = null,
}) {
  const { Title } = Typography;

  return (
    <>
      <div className='linechart'>
        <div>
          <Title level={5}>{title}</Title>
        </div>
        {topRightChildren}
      </div>

      <ReactApexChart
        className='full-width'
        options={options}
        series={series}
        type='line'
        height={height}
        width={width}
      />
    </>
  );
}

export default LineChart;
